// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"95":"adc327eadec91bcead60","194":"8e51df1775d13142073d","318":"d79d95f2c5f48a833ada","529":"a4355d9dd57d9b2476be","964":"0a0f8665ff52bfa36cd4"}[chunkId] + ".js";
};